import {buildTourProgressElement} from '../../../../resources/js/product-tours.js'

export const NURSE_PERFORMANCE_TOUR_STEPS = [
    {
        selector: '[data-cy="nurse-performance-toggle"]',
        position: 'bottom-start',
        title: 'Your month, in one view',
        body: 'These metrics are part of how your work is evaluated and may affect future patient assignments. Assignment readiness looks at four measures of consistency:',
        items: [
            {label: 'Completion', description: 'Complete your monthly caseload'},
            {label: 'Planning', description: 'Keep your calendar current by entering your days off'},
            {label: 'Reliability', description: 'Work the days your calendar shows you are available'},
            {label: 'Timely releases', description: 'Release patients early so another nurse can schedule them. Releases after the 20th may be reviewed and may affect this metric.'},
        ],
        note: 'It is okay to have a small caseload. You are not being asked to grow it.',
    },
    {
        selector: '[data-tour="nurse-daily-coach"]',
        position: 'bottom',
        title: 'Plan today\u2019s work',
        body: 'Your target is how many cases to complete today to stay on pace for the month. It is set at the start of the day and holds still while you work. The bar under it fills as you finish patients.',
    },
    {
        selector: '[data-tour="nurse-monthly-completion"]',
        position: 'bottom',
        title: 'Check your monthly progress',
        body: 'This shows completed cases, cases left, and workdays remaining, so you can plan the rest of the month.',
    },
    {
        selector: '[data-tour="nurse-tier"]',
        position: 'top',
        title: 'Understand your tier',
        body: 'Your tier is based on your completion rate across qualifying months. It may affect which assignments you can take. Caseload size does not determine your tier.',
        note: 'Qualifying months are eligible months within the last six months. They do not need to be consecutive.',
    },
    {
        selector: '[data-tour="nurse-historic-performance"]',
        position: 'left',
        title: 'Review your last six months',
        body: 'Each bar shows how many patients you served that month, with its releases underneath. Select a month to see the details, including case completion. Use the six-month trend to review your consistency over time.',
    },
    {
        selector: '[data-tour="nurse-team-progress"]',
        position: 'top',
        title: 'See the team’s progress',
        body: 'This is all the patients the team has to serve this month.',
    },
    {
        selector: '[data-tour="nurse-team-benchmark"]',
        position: 'top',
        title: 'Read the team benchmark',
        body: 'This compares your completed cases with top team results. It is context, not a required target. Caseload size, schedule, and patient complexity vary by nurse.',
    },
    {
        selector: '[data-cy="nurse-performance-toggle"]',
        position: 'bottom-start',
        title: 'Use the metrics to self-manage',
        body: 'Use these metrics to self-manage your month. A few Slightly behind or Catch-up needed days are okay if you catch up. Frequent Catch-up needed days may lead to patient reassignments.',
        note: 'When your metrics stay in good standing, no reassignment or follow-up is needed.',
    },
]

export function buildTourStepElement(step, index, total, documentObject = document) {
    const content = documentObject.createElement('div')
    content.append(buildTourProgressElement(index, total, documentObject))

    const body = documentObject.createElement('p')
    body.className = 'nurse-performance-tour-body'
    body.textContent = step.body
    content.append(body)

    if (step.items?.length) {
        const list = documentObject.createElement('ul')
        list.className = 'nurse-performance-tour-list'

        step.items.forEach((item) => {
            const listItem = documentObject.createElement('li')
            const marker = documentObject.createElement('span')
            marker.className = 'nurse-performance-tour-list-marker'
            marker.setAttribute('aria-hidden', 'true')

            const description = documentObject.createElement('span')
            const label = documentObject.createElement('strong')
            label.textContent = `${item.label}:`
            description.append(label, documentObject.createTextNode(` ${item.description}`))

            listItem.append(marker, description)
            list.append(listItem)
        })

        content.append(list)
    }

    if (step.note) {
        const note = documentObject.createElement('p')
        note.className = 'nurse-performance-tour-note'
        note.textContent = step.note
        content.append(note)
    }

    return content
}
